export class Token {
    symbol: string;
    address: string;
    decimals: number;
    chainId: number;
    name: string;
    icon: string;
}
